import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate } from 'react-localize-redux';
import { reportActions } from '../../../store/reportStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import VehicleRow from './vehicleRow';
import Paging from '../../common/pagingComponent';
import ExcelExportButton from '../../common/excelExportButton';

import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

class ListOfVehicles extends React.Component {
    state = { page: 1 };

    get section() {
        return this.props.sections.find(o => o.id === this.props.sectionId);
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.sectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    render() {
        const { data, loadingMoreData, isLimited } = this.section;

        if (isNullOrUndefined(data) || isNullOrUndefined(data.items))
            return null;

        const max = data && isLimited && data.items.length > this.pageSize * this.state.page ? this.pageSize * this.state.page : data.items.length;
        const items = data.items.slice(0, max);
        if (isLimited && (data.items.length < data.totalCount || data.items.length > max)) {
            items.push("renderMoreLinks");
        }

        return (
            <div>
                <OldStyleTableWithHistory
                    colWidths={['7%', '10%', '10%', '10%', '10%', '10%', '10%', '10%', '10%', '13%']}
                    head={() => <thead>
                        <tr>
                            <th></th>
                            <th><Translate id="Report.ListOfVehicles.VehicleCategory" /></th>
                            <th><Translate id="Report.ListOfVehicles.VehicleUsedNew" /></th>
                            <th><Translate id="Report.ListOfVehicles.DateOf1stRegistration" /></th>
                            <th><Translate id="Report.ListOfVehicles.DateFirstRegistrationCzechRepublic" /></th>
                            <th><Translate id="Report.ListOfVehicles.FinancialLeasing" /></th>
                            <th><Translate id="Report.ListOfVehicles.Operator" /></th>
                            <th><Translate id="Report.ListOfVehicles.Owner" /></th>
                            <th><Translate id="Report.ListOfVehicles.MainColor" /></th>
                            <th><Translate id="Report.ListOfVehicles.Brand" /></th>
                        </tr>
                    </thead>}
                    actualData={items} fixed classNames='old-style-bordered'
                    actualRow={v => <>
                        {v !== "renderMoreLinks" && <VehicleRow key={v.id} data={v} />}
                        {v === "renderMoreLinks" && this.renderMoreLinks(data.items.length, data.totalCount, loadingMoreData)}
                    </>}
                />
                {!isLimited && data.totalCount > this.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={this.state.page}
                        totalPages={Math.ceil(data.totalCount / this.pageSize)}
                        setPage={page => this.onChangePage(page)}
                    />
                </div>}
                <ExcelExportButton link="vehicles" entityId={this.props.id} report={this.props.reportType} />
            </div>
        )
    }

    renderMoreLinks = (loadedCount, totalCount, isLoading) => {
        return (
            <tr>
                <td colSpan={10}>
                    <div>
                        {this.state.page >= 2
                            ? <a href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, this.props.sectionId)}
                                target="_blank" className="link-functional">
                                <Translate id="Report.Common.ShowAll" />&nbsp;({totalCount})
                            </a>
                            : <span className="link-functional" onClick={() => this.getMore(loadedCount)} ><Translate id="Report.Common.More" /></span>}
                    </div>
                    {isLoading === true && <div style={{ width: "100%" }} className="search-progress searching"></div>}
                </td>
            </tr>
        );
    }

    getMore = (loadedCount) => {
        this.props.fetchMoreData(
            [this.props.sectionId],
            { count: this.pageSize, offset: loadedCount, report: this.props.reportType },
            null, this.concatData, () => this.setState({ page: 2 })
        );
    }

    onChangePage = (page) => {
        this.props.fetchMoreData(
            [this.props.sectionId],
            { count: this.pageSize, offset: (page - 1) * this.pageSize, report: this.props.reportType },
            null, this.replaceData, () => this.setState({ page: page })
        );
    }

    concatData = (_hint, oldData, newData) => {
        return {
            items: oldData.items.concat(newData.items),
            totalCount: oldData.totalCount
        }
    }

    replaceData = (_hint, _oldData, newData) => newData;
}

export default connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(ListOfVehicles);